import { cn } from '@/lib/utils';
import { LucideProps } from 'lucide-react';
import { ForwardRefExoticComponent, RefAttributes } from 'react';

interface Props {
  lucideIcon: ForwardRefExoticComponent<Omit<LucideProps, 'ref'> & RefAttributes<SVGSVGElement>>;
  size?: number;
  className?: string;
}

export function Icon({ lucideIcon: LucideIcon, size = 24, className }: Props) {
  return <LucideIcon className={ cn('stroke-[1.33px]', className) } size={ size } />;
}
